export default "__VITE_ASSET__DdF7_Z7W__"